// extracted by mini-css-extract-plugin
export default {"warp":"preset_apps_warp__FMm34","home_title":"preset_apps_home_title__BFiTM","foot":"preset_apps_foot__wieKW"};